export default "__VITE_ASSET__Cqnaxist__"